import { useTranslation } from "react-i18next"
import s from "./NoPortalAccess.module.scss"

export const NoPortalAccess = () => {
  const { t } = useTranslation()

  return <div className={s.noPortalAccess}>{t("notFound.NOT_ENABLED")}</div>
}
